import Cookies from 'js-cookie';

// Formats a place to be stored as the user's selected location in the Redux userSlice.
// `city_ids` (all CW-confirmed ids from the cwautocomplete picker, when present) are carried
// through so the selected location can be resolved without re-deriving them. Tolerates a
// legacy singular `city_id` from places saved before the array switch.
export const normalizePlaceForSelectedLocation = (place) => ({
  placeId: place.place_id,
  title: place.title || place.term,
  city: place.city,
  state: place.state_long,
  latitude: place.latitude ?? place.geometry?.location?.lat,
  longitude: place.longitude ?? place.geometry?.location?.lng,
  city_ids: place.city_ids ?? (place.city_id ? [place.city_id] : []),
});

export const buildLocationAPIPayload = (location) => ({
  city: location.city,
  state: location.state,
  latitude: location.latitude,
  longitude: location.longitude,
});

export const readUserIdentityFromCookies = () => ({
  email: Cookies.get('email'),
  username: Cookies.get('username'),
  organization: Cookies.get('organizationName') || 'undefined',
});
